import Vue from "vue"
import axios from "axios"
// import Router from '@/router/index.js'
import Loading from "./loading.js"
import { Message } from "element-ui"
// import {
//   removeStore
// } from './utils.js'

const _axios = axios.create({
  baseURL: "",
  timeout: 9000000 // request timeout
})

// 添加请求拦截器
_axios.interceptors.request.use(
  function(config) {
    if (config.vconfig && !config.vconfig.neverLoading) {
      Loading.start(config.vconfig.loadText) // 自定义loading下面的文字
    }
    config.headers.Authorization = `Bearer ${Vue.prototype.$keycloak.token}`
    return config
  },
  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 添加响应拦截器
_axios.interceptors.response.use(
  response => {
    // 没有loading的请求，不需要再关闭loading了
    if (response.config.vconfig && !response.config.vconfig.neverLoading) {
      Loading.close()
    }
    if (response.data && response.data.status !== 0) {
      Message.error({
        message: response.data.data ? response.data.data : response.data.message
      })
    }
    return response.data
  },
  error => {
    Loading.close()
    // 对响应错误做点什么，比如400、401、402等等
    if (error && error.response) {
      // console.log(error.response);
      // if (error.response && !error.response.config.url.includes('protocol/openid-connect/token') && error.response.status === 401) { // 没有权限或token过期，跳转到登录页
      //   removeStore('authorization')
      //   removeStore('enterpriseId')
      //   removeStore('username')
      //   Router.push('/login')
      // }
      // 错误统一处理
      Message.error({
        message: error.response.data && error.response.data.error
      })
    }
    // return Promise.reject(error)
  }
)

export default _axios
